// extracted by mini-css-extract-plugin
module.exports = {"myServer":"index-module_myServer_2Fzuv","toolList":"index-module_toolList_2Hxmh","iconBadge":"index-module_iconBadge_fNBpr"};